export default {
  default: { text: "" }
  , required: { text: "El campo es obligatorio" }
  , minLength: {
    text: "No cumple con la longitud mínima"
    , template: "No cumple con la longitud mínima ({min})"
  }
  , maxLength: {
    text: "Se ha excedido la longitud máxima"
    , template: "Se ha excedido la longitud máxima ({max})"
  }
  , email: { text: "No es un email válido" }
  , emailList: { text: "La lista de emails no es válida" }
  , sameAs: { text: "El valor no es igual al anterior" }
  , isZeroValue: { text: "Se permite ingresar el valor en 0" }
  , isCPNotZeroValue: { text: "No se permite ingresar un código postal en 0" }
  , minDateFrom: { text: "La fecha no puede ser menor" }
  , maxDateFrom: { text: "La fecha no puede ser mayor" }
  , maxValue: { template: "Excede el valor máximo ({max})" }
  , minValue: {
    text: "Prioridad mínima 1"
    , template: "No cumple con el valor mínimo ({min})"
  }
  , integer: { text: "Solo números enteros" }
  , numeric: { text: "Solo números enteros" }
  , onlyIntegers: { text: "Solo números enteros" }
  , alphaNumDot: { text: "Caracteres no permitidos" }
  , alphaNumDotUnderscore: { text: "Solo se permiten letras, números, puntos y guiones bajos" }
  , decimal: { text: "Solo números" }
  , isDecimalTwoPrecision: { text: "Solo se aceptan valores decimales a 2 posiciones" }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/validator/index.js